var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"luckdraw",staticClass:"base-luckdraw"},[_c('div',{staticClass:"lucktable",style:({ transform: _vm.rotateAngle, transition: _vm.rotateTransition })},[_c('div',{staticClass:"prize-bg",style:({
        backgroundImage: `url(${_vm.mValue.bg || _vm.defaultBg})`,
        ..._vm.prizeBgStyle
      })}),_c('div',{staticClass:"prize"},_vm._l((_vm.listValue),function(item,index){return _c('div',{key:index,staticClass:"item",style:(_vm.getRotateAngle(index))},[_vm._t("item",null,{"item":item})],2)}),0)]),_c('div',{staticClass:"pointer",style:({
      backgroundImage: `url(${_vm.mValue.btn || _vm.defaultBtn})`,
      ..._vm.pointerStyle
    }),on:{"click":_vm.startTurns}})])
}
var staticRenderFns = []

export { render, staticRenderFns }